/**
 * @auther  yuyuanda
 *  入口文件
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets

// 引入权限控制
import './permission'

// 引入全局样式
import '@/styles/index.scss'

// 全局引入Vant
import Vant from 'vant'
import 'vant/lib/index.css'

// 全局引入Element-UI分部元素
import { Button, Select, Message } from 'element-ui'

// 全局引入dayjs
import dayjs from 'dayjs'

// 防抖自定义指令
import Debounce from '@/core/directive/directive.js'

Vue.use(Vant)
Vue.use(Button)
Vue.use(Select)
Vue.prototype.$message = Message
// 添加防抖指令，使用方法：v-debounce
Debounce(Vue)
Vue.prototype.$d = dayjs
// Vue.config.devtools = true
Vue.config.productionTip = false

// 记录页面加载时的 URL，微信 WebView SPA 签名需与此一致；非微信环境同样无害
sessionStorage.setItem('__init_url__', window.location.href.split('#')[0])

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
